import { Link, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import type { User } from "../lib/types";

export function Header({ user }: { user: User | null }) {
  const navigate = useNavigate();
  async function onLogout() {
    await api.logout().catch(() => {});
    navigate("/login");
  }
  return (
    <header className="app-header">
      <Link to="/" className="brand">♟ ourchess</Link>
      {user ? (
        <div className="flex-row">
          {user.isAdmin && (
            <Link to="/admin" className="btn secondary" style={{ minHeight: 44, padding: "0.5rem 0.75rem", fontSize: "1rem" }}>
              Invite
            </Link>
          )}
          <button
            className="secondary"
            onClick={onLogout}
            style={{ minHeight: 44, padding: "0.5rem 0.75rem", fontSize: "1rem" }}
          >
            Sign out
          </button>
        </div>
      ) : null}
    </header>
  );
}
